import { ReviewModeParams } from './../../../../communication-structure/review-mode-params';
import { Skill } from './../../../../communication-structure/auto-training-code-model';
import { CompletionCellData } from './../../../table/table.component';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild , ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { saveAs } from 'file-saver';
import * as XLSX from '../../../../../xlsx';
import { ApplicationList } from '../../../../communication-structure/application-list';
import { AutoTrainingCodeModel } from '../../../../communication-structure/auto-training-code-model';
import { CommunicationProxyService } from '../../../../services/communication-proxy.service';
import { LoginService } from '../../../../services/login.service';
import { StringTableService } from '../../../../services/string-table.service';
import { PageViewComponent } from '../../../page-view/page-view.component';
import { Table, Types } from '../../../table/table.component';
import { ATCTYPE } from '../../email-invite/email-invite.component';
import { STATUS_CLASS } from '../../email-sent/email-sent.component';
import { activeReportingPageEnum } from '../reporting/reporting.component';
import {  MainComponent } from '../../../main-component/main.component';
import { Accordion, AccordionRow, AccordionRowTypes} from '../../../data-accordion/data-accordion.component';

@Component({
  selector: 'app-reporting-home',
  templateUrl: './reporting-training-home.component.html',
  styleUrls: ['./reporting-training-home.component.scss']
})
export class ReportingTrainingComponent extends PageViewComponent implements OnInit {
  selectedElement: any;
  public currentSelectedAccordion: any;
  private autoTrainingCodeList: AutoTrainingCodeModel[] = [];
  public popupState = false;
  public pieChartItemValue: any;
  public pieChartPieChartType: any;
  showReportTitle: string;
  @Input() accordions;
  public accordianToDisplay: Accordion[] = [];
  @ViewChild('subAccordion') subAccordion;
  @Output() linkClicked = new EventEmitter<object>();
  @Input() enableShowReport = true;
  @Output() popupShow = new EventEmitter<object>();
  @Output() subAccordianClicked = new EventEmitter<object>();
  @ViewChild('popupTable') popupTable;
  isExpanded = false;
  public legendData = [];
  noAttempt: string;
  title: string | number;
  public trainingDeadlineDate: string;
  public remainingDaysTitle: string;
  public remainingDays: string | number;
  private headerTitleArray: string[] = [];
  private totalAccordions: Accordion[] = [];
  private dataAccordion: Accordion;
  private tableHeader: Table[] = [];
  private allCheckBoxes;
  public pieChartData: number[] = [];
  public totalAtcCount = 0;
  public timeInvested: string;
  private displayTable: Table[][];
  public totalParentAccordions: Accordion[] = [];
  public totalChildAccordians: Accordion[] = [];
  public pageTitle: string;
  public pageDesc: string;
  public selectTitle: string;
  public startDateTitle: string;
  public endDateTitle: string;
  public filterDropdownTitle: string;
  public dropdownPlaceholder: string;
  getClientATCList: string;
  GetAtc: string;
  getAssignmentsEndPoint : string;
  getAllApplicationWithScoreForAtc: string;
  trainingData: Array<AutoTrainingCodeModel>;
  dropdownData: Array<{ id: string, name: string }>;
  filterOptions: Array<{ id: number, name: string }>;
  atcSelected: string = null;
  atcName: string;
  header: Table[];
  displayedTable: Table[][];
  fullTable: Table[][];
  dateFilteredTable: Table[][] = null;
  applicationList: Array<ApplicationList>;

  private startDate: { date: Date, isDateValid: boolean } = { date: null, isDateValid: false };
  private endDate: { date: Date, isDateValid: boolean } = { date: null, isDateValid: false };
  isStartDateValid: boolean;
  isEndDateValid: boolean;
  private formattedStartDate: Date;
  private formattedEndDate: Date;
  noOfColumns: number;

  @ViewChild('SelectTraining') selectTrainingDropdown;
  @ViewChild('StatusDropdown') statusDropdown;
  @ViewChild('detailsTable') detailsTable;
  @ViewChild('startDate') startDateBox;
  @ViewChild('endDate') endDateBox;
  @ViewChildren('checkBox') private checkBoxArray;

  @Output() onScoreDetailsReportClick = new EventEmitter<{ activePage: number, applicationList: ApplicationList[],
    atcId: string, atcName: string }>();
  @Input() previousAtcId: string;

  private reviewMode: string;
  private redirectUrl: string;
  private dashboardRoute: string;
  private queryParam1: string;
  private queryParam2: string;

  public btnData: { name: string, icon: string } = { name: '', icon: '' };

  // boolean to distinguish between email-sent & reporting component
  isReporting = true;
  isExtendedTable: boolean;

  /**
   * An array of array containing the data which is to be sent to sheet js for creating
   * a excel file.
   */
  private dataForSheetJs: any[][];

  private xlsxWritingOptions: XLSX.WritingOptions = { bookType: 'xlsx', type: 'array' };

  /**
   * The file name of the sheet generated.
   */
  private excelFileName = '';

  /**
   * The rows which are shown in excel.
   */
  private tableRowsForExcel: Table[][] = [];

  /**
   * The color which should be applied to the 1st row in the created excel.
   */
  private headerHexColorName = '';

  private applicationMap: Map<string, string>;

  constructor(ele: ElementRef,
    remoteProxy: CommunicationProxyService,
    protected loginService: LoginService,
    stringTableService: StringTableService,
    protected router: Router,
    protected cdr: ChangeDetectorRef) {
    super(ele, remoteProxy, loginService, stringTableService, router);
    this.retrieveStrings();
  }

  ngOnInit() {
    this.createHeader();
    this.getClientAtcList(ATCTYPE.ACTIVE);
    this.getClientTrainingList();
    this.selectTrainingDropdown.setFocus();
    if (MainComponent.getAtcData() === undefined) {
    } else {
      this.setAtcListData();
    }

    if (MainComponent.getTrainingList() === undefined) {
      this.getClientTrainingList();
    }

    this.applicationMap = new Map([
      ['word19', 'word'],
      ['powerpoint19', 'powerpoint'],
      ['access19', 'access'],
      ['excel19', 'excel'],
      ['outlook19', 'outlook'],
    ]);
  }

  retrieveStrings() {
    this.redirectUrl = this.stringTableService.getEndpoint('OidcConfiguration').redirect_uri;
    this.reviewMode = this.stringTableService.getString('reviewModeParams', 'mode');
    this.dashboardRoute = this.stringTableService.getString('reviewModeParams', 'reviewRoute');
    this.queryParam1 = this.stringTableService.getString('reviewModeParams', 'queryParam1');
    this.queryParam2 = this.stringTableService.getString('reviewModeParams', 'queryParam2');
    this.pageTitle = this.stringTableService.getString('reportingTraining', 'pageTitle');
    this.pageDesc = this.stringTableService.getString('reportingTraining', 'pageDesc');
    this.selectTitle = this.stringTableService.getString('emailsSent', 'selectTitle');
    this.startDateTitle = this.stringTableService.getString('createAutoTrainingCode', 'startDateTitle');
    this.endDateTitle = this.stringTableService.getString('createAutoTrainingCode', 'endDateTitle');
    this.filterDropdownTitle = this.stringTableService.getString('emailsSent', 'filterDropdownTitle');
    this.dropdownPlaceholder = this.stringTableService.getString('labels', 'all');
    this.getClientATCList = this.stringTableService.getEndpoint('GetClientATCList');
    this.getAllApplicationWithScoreForAtc = this.stringTableService.getEndpoint('GetAllApplicationWithScoreForAtc');
    this.headerHexColorName = this.stringTableService.getString('colors', 'excelHeaderColumnColor');
    this.excelFileName = this.stringTableService.getString('fileNames', 'excelFileName');
    this.filterOptions = [{ id: 0, name: this.stringTableService.getString('labels', 'all') },
      { id: 1, name: this.stringTableService.getString('labels', 'completed') },
      { id: 2, name: this.stringTableService.getString('labels', 'incomplete') }];
    this.getAssignmentsEndPoint = this.stringTableService.getEndpoint('GetAssignments');
    this.GetAtc = this.stringTableService.getEndpoint('GetAtc'),
    this.btnData = {
      name: this.stringTableService.getString('labels', 'saveToExcel'),
      icon: this.stringTableService.getString('icons', 'file-excel')
    };
  }

  createHeader() {
    this.header = [
      new Table(Types.TEXT, 'table-header', this.stringTableService.getString('labels', 'name')),
      new Table(Types.TEXT, 'table-header', this.stringTableService.getString('labels', 'email')),
      new Table(Types.TEXT, 'table-header', this.stringTableService.getString('emailsSent', 'dateSent')),
      new Table(Types.TEXT, 'table-header', this.stringTableService.getString('reportingTraining', 'dateDone')),
      new Table(Types.TEXT, 'table-header', this.stringTableService.getString('reportingTraining', 'completionProgress')),
      new Table(Types.TEXT, 'table-header', this.stringTableService.getString('reportingTraining', 'scoreDetails')),
      new Table(Types.TEXT, 'table-header', this.stringTableService.getString('reportingTraining', 'scoreDashboard')),
    ];
    const headerClone = JSON.parse(JSON.stringify(this.header));
    // -1 cause 1 extra column is added to the table.
    this.noOfColumns = headerClone.length - 1;
    this.dataForSheetJs = this.parseDataForSheetJs([headerClone]);
  }

  private parseDataForSheetJs(tableData: any): any[][] {
    const parsedDataForSheet: any[][] = [[]];
    let i = 0, j = 0;
    for (const row of tableData) {
      parsedDataForSheet[i] = [];
      for (const data of row) {
        if ((j === 0 && data.title === '') || (j === this.noOfColumns)) {
          continue;
        }
        if (data.type !== 1 || data.type !== 6 || data.type !== 5) {
          parsedDataForSheet[i][j] = data.title;
        }
        j += 1;
      }
      j = 0;
      i += 1;
    }
    return parsedDataForSheet;
  }

  private saveToExcelClicked() {
    this.tableRowsForExcel = this.displayedTable;
    if (this.tableRowsForExcel.length > 0) {
      this.dataForSheetJs.splice(1, this.dataForSheetJs.length - 1);
      const tableClone = JSON.parse(JSON.stringify(this.tableRowsForExcel));
      Array.prototype.push.apply(this.dataForSheetJs, this.parseDataForSheetJs(tableClone));

      const workSheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(this.dataForSheetJs);
      let noOfHeadersFormated = 0;
      for (const cell in workSheet) {
        if (workSheet.hasOwnProperty(cell)) {
          if (cell === '!ref') {
            continue;
          }
          noOfHeadersFormated += 1;
          if (noOfHeadersFormated !== this.noOfColumns + 1) {
            workSheet[cell].bold = true;
            workSheet[cell].fillColor = true;
          } else {
            break;
          }
        }
      }

      /* generate workbook and add the worksheet */
      const workbook: XLSX.WorkBook = XLSX.utils.book_new();
      (workbook as any).headerColor = this.headerHexColorName;
      XLSX.utils.book_append_sheet(workbook, workSheet, 'Sheet1');

      /* save to file */
      const workBookOutputBuffer: ArrayBuffer = XLSX.write(workbook, this.xlsxWritingOptions);
      saveAs(new Blob([workBookOutputBuffer], { type: 'application/octet-stream' }), this.excelFileName);
    } else {
      this.validationPopup = true;
      this.showDialog({title: "Error", body: "There are no training data available"});
    }
  }

  /**
   *
   * @param activeStatus the type of ATC list which we want to fetch 0 - inactive, 1 - active, 2 - both
   */
  getClientAtcList(activeStatus) {
    this.getDataFromApi(this.getClientATCList, { clientId: this.currentUserClientID, active: activeStatus })
      .subscribe(this.handleClientAtcListData.bind(this),
      this.handleSubscriptionError.bind(this, this.getClientAtcList.bind(this, activeStatus), false));
  }

  /**
   * create table using response
   * @param data response from server
   */
  handleClientAtcListData(data) {
    this.hideLoader();
    this.trainingData = data.autoTrainingCodeList;
    this.dropdownData = [];

    for (const record of this.trainingData) {
      this.dropdownData.push({ id: record.autoTrainingCodeId, name: record.autoTrainingCodeName });
    }
    this.initView();
  }

  /**
   * Initial View of report home page when back button is clicked of
   * pass-fail report, graphical report.
   */
  initView() {
    if (this.previousAtcId) {
      const index = this.dropdownData.findIndex(record => record.id === this.previousAtcId);
      this.atcName = this.dropdownData[index].name;
      this.atcSelected = this.dropdownData[index].id;
      this.getClientApplicationWithScore(this.previousAtcId);
      
    }
  }

  handleATCListData(data) {
    super.handleATCListData(data);
    this.setAtcListData();
  }
  setAtcListData() {
    const data = this.getHandeledAtcData();
    this.trainingDeadlineDate = this.formatDate(this.dateConversion(data.dueDate));
    this.remainingDays = this.calculateDaysDiff(data.dueDate);
    this.autoTrainingCodeList = data.autoTrainingCodeList;
    this.gatherData();
  }

  gatherData() {
    let timeInvestedTotal = 0;
    this.cdr.detectChanges();
    this.allCheckBoxes = this.checkBoxArray.toArray();
    for (const headerTitle of this.headerTitleArray) {
      this.tableHeader.push(new Table(Types.TEXT, 'table-header', headerTitle));
    }

    for (const atc of this.autoTrainingCodeList) {
      timeInvestedTotal += atc.timeInvested;
      const accordionHeader = new AccordionRow(AccordionRowTypes.PIE_CHART, atc.autoTrainingCodeName, atc.desc, this.calcAtcCompletionPerc(atc.skillList));
      const accordionData = new AccordionRow(AccordionRowTypes.TABLE, this.tableHeader, this.formTable(atc.skillList));
      this.dataAccordion = new Accordion(accordionHeader, accordionData);
      this.totalAccordions.push(this.dataAccordion);
    }

    this.timeInvested = this.secondsToHms(timeInvestedTotal);
    this.pieChartData = [this.unattemptedATCCount, this.inprogressATCCount, this.completeATCCount];
    this.totalAtcCount = this.autoTrainingCodeList.length;

    this.legendData = [
      {
        itemValue: this.completeATCCount, labelName: 'Completed',
        colourIndicator: this.stringTableService.getString('colors', 'completeLabelColor')
      },
      {
        itemValue: this.inprogressATCCount, labelName: 'Inprogress',
        colourIndicator: this.stringTableService.getString('colors', 'inProgressLabelColor')
      },
      {
        itemValue: this.unattemptedATCCount, labelName: 'Unattempted',
        colourIndicator: this.stringTableService.getString('colors', 'unattemptedLabelColor')
      }
    ];
    this.setSelectedAccordianData();
  }
  setSelectedAccordianData() {
    const tempAccordion = [];
    this.allCheckBoxes.forEach((checkbox) => {
      if (checkbox.isSelected === true) {
        const records = this.getCheckedCategoryData(checkbox.data);
        for (const record of records) {
          tempAccordion.push(record);
        }
      }
    });
    this.accordianToDisplay = this.sortAccordiansPerChartType(tempAccordion);
    this.shortSkillsAsperClientTrainingList(this.accordianToDisplay);
    this.accordianToDisplay = this.shortGroupAccToSkillName(JSON.parse(JSON.stringify(this.accordianToDisplay)));
  }
  sortAccordiansPerChartType(array) {
    return array.sort(function (a, b) {
      return a.header.chartData.chartType - b.header.chartData.chartType || a.header.chartData.itemValue - b.header.chartData.itemValue;
    });
  }
  shortSkillsAsperClientTrainingList(acoredionData) {
    for (let acordion of acoredionData) {
      for (let row of acordion.content.table) {
        let index = this.findIndexOfSkillInClientTrainingList(row[0].title);
        if (index !== -1) {
          row[0].priority = index;
        }
      }
      acordion.content.table = this.shortAcordionByPriority(JSON.parse(JSON.stringify(acordion.content.table)));
    }
  }
  shortAcordionByPriority(table) {
    return table.sort(function (a, b) {
      return a[0].priority - b[0].priority;
    });
  }

  shortGroupAccToSkillName(acoredionData) {
    for (let a = 0; a < acoredionData.length; a++) {
      const accordion = acoredionData[a];
      for (let b = a + 1; b < acoredionData.length; b++) {
        const aco = acoredionData[b];
        for (let i = 0; i < accordion.content.table.length; i++) {
          for (let j = 0; j < aco.content.table.length; j++) {
            if (aco.header.chartData.chartType === accordion.header.chartData.chartType) {
              if (accordion.content.table[i][0].priority > aco.content.table[j][0].priority) {
                const temp = JSON.parse(JSON.stringify(aco));
                acoredionData[b] = JSON.parse(JSON.stringify(accordion));
                acoredionData[a] = temp;
                i = accordion.content.table.length;
                j = aco.content.table.length;
              } else {
                if (accordion.content.table[i][0].priority < aco.content.table[j][0].priority) {
                  i = accordion.content.table.length;
                  j = aco.content.table.length;
                }
              }
            }
          }
        }
      }
    }
    return acoredionData;
  }
  getCheckedCategoryData(checkedCategory) {
    const tempAccordion = [];
    for (const accordion of this.totalAccordions) {
      if (accordion.header.chartData.chartType === checkedCategory) {
        tempAccordion.push(accordion);
      }
    }
    return tempAccordion;
  }
  formTable(skillList) {
    this.displayTable = [];
    for (const skill of skillList) {
      this.displayTable.push([
        new Table(Types.IMG_TEXT, this.getApplicationIconPath(skill.applicationName), skill.skillName, skill.skillLaunchLink),
        new Table(Types.TEXT, 'table-data', skill.questionCount),
        new Table(Types.TEXT, 'table-data', skill.attempts),
        new Table(Types.TEXT, 'table-data', skill.obtainedScore + '/' + skill.totalScore)
      ]);
    }
    return this.displayTable;
  }
  secondsToHms(d) {
    d = Number(d);
    const h = Math.floor(d / 3600);
    const m = Math.floor(d % 3600 / 60);
    const s = Math.floor(d % 3600 % 60);
    if (h > 0) {
      return h + (h === 1 ? ' Hour' : ' Hours');
    } else {
      return m > 0 ? m + (m === 1 ? ' Minute' : ' Minutes') : '0';
    }
  }

  calculateDaysDiff(date) {
    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    const firstDate = new Date(date);
    const secondDate = new Date();
    let diffDays = 0;
    if (firstDate > secondDate) {
      diffDays = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / (oneDay)));
    }
    const daysString = diffDays > 0 ? diffDays + (diffDays === 1 ? ' day' : ' days') : diffDays;
    return daysString;
  }
  getAssignments() {
    this.getDataFromApi(this.getAssignmentsEndPoint, {})
      .subscribe(this.handleAssignmentData.bind(this),
        this.handleSubscriptionError.bind(this, this.getAssignments.bind(this), false));
  }

  handleAssignmentData(data) {
    this.hideLoader();
    const dataFromApi = data.assignments;
    this.setAccordianData(dataFromApi);
  }

  setAccordianData(assignmentData) {
    for (let i = 0; i < this.tableHeaderCols.length; i++) {
      this.header.push(new Table(Types.TEXT, 'table-header', this.tableHeaderCols[i]));
    }

    for (const assignment of assignmentData) {
      const parentAccordionHeader = new AccordionRow(
        AccordionRowTypes.TITLE_DESC, assignment.assignmentName, assignment.assignmentDescription);
      for (const skill of assignment.skills) {
        const childAccordionHeader = new AccordionRow(AccordionRowTypes.PERCENT_BAR, skill.skillName, skill.skillCompletion);
        const childAccordianData = new AccordionRow(AccordionRowTypes.TABLE, this.header, this.setTableData(skill.scoreSummary));
        this.dataAccordion = new Accordion(childAccordionHeader, childAccordianData);
        this.totalChildAccordians.push(this.dataAccordion);
      }
      const parentAccordionData = new AccordionRow(AccordionRowTypes.ACCORDION, this.totalChildAccordians);
      this.dataAccordion = new Accordion(parentAccordionHeader, parentAccordionData);
      this.totalParentAccordions.push(this.dataAccordion);
    }
  }
  
  setTableData(data) {
    const tableData: Table[][] = [];
    for (const row of data) {
      const tableRow = [];
      tableRow.push(new Table(Types.TEXT, 'table-data', '1'));
      tableRow.push(new Table(Types.TEXT, 'table-data', row.attemptDate));
      tableRow.push(new Table(Types.TEXT, 'table-data', row.questionCount));
      tableRow.push(new Table(Types.TEXT, 'table-data', row.scoreObtained + '/' + row.totalScore));
      tableRow.push(new Table(Types.TEXT, 'table-data', row.correctResponse));
      tableRow.push(new Table(Types.TEXT, 'table-data', row.incorrectResonse));
      tableRow.push(new Table(Types.TEXT, 'table-data', row.skippedQuestionCount));
      tableRow.push(new Table(Types.LINK_ICON, 'tg-arrow-up2', this.linkStr));
      tableData.push(tableRow);
    }
    return tableData;
  }

  /**
   *
   * @param data info about the ATC selected in dropdown
   */
  onMenuItemChange(data) {
    this.getClientApplicationWithScore(data.id);
    this.resetAll();
    this.atcSelected = data.id;
    this.atcName = data.name;
  }

  resetAll(){
    this.clearDates();
    this.statusDropdown.resetDropDownTextBox();
  }

  getClientApplicationWithScore(atcId) {
    this.getDataFromApi(this.getAllApplicationWithScoreForAtc, { clientId: this.currentUserClientID, autoTestCodeId: atcId })
      .subscribe(this.handleClientApplicationEmail.bind(this),
      this.handleSubscriptionError.bind(this, this.getClientApplicationWithScore.bind(this, atcId), false));
  }

  handleClientApplicationEmail(data) {
    this.hideLoader();
    this.fullTable = [];
    this.applicationList = data.applicationList;

    for (let count = 0; count < this.applicationList.length; count++) {
      const currentCandidate = this.applicationList[count];
      const isComplete = this.applicationList[count].completedDate !== '';
      const tableClass = isComplete ? STATUS_CLASS.COMPLETED : STATUS_CLASS.INCOMPLETE;
      const map: Map<string, CompletionCellData>  = new Map();
      currentCandidate.skillList.forEach((skill: Skill) => {
        let applicationName = skill.applicationName.toLowerCase();
        if(this.applicationMap.has(applicationName)){
          applicationName = this.applicationMap.get(applicationName);
        }
        if (map.has(applicationName)) {
          map.get(applicationName).completedTasks += skill.attempts > 0 ? 1 : 0;
          map.get(applicationName).totalTasks += 1;
        } else {
          map.set(applicationName, {
            strClass: this.getApplicationIconPath(skill.applicationName),
            completedTasks: skill.attempts > 0 ? 1 : 0,
            totalTasks: 1
          });
        }
      });
      const tableRow = [
        new Table(Types.TEXT, tableClass, currentCandidate.candidateName),
        new Table(Types.TEXT, tableClass, currentCandidate.candidateEmail),
        new Table(Types.DATE, tableClass, this.formatDate(this.dateConversion(currentCandidate.sentDate))),
        new Table(Types.DATE, tableClass, this.formatDate(this.dateConversion(currentCandidate.completedDate))),
        new Table(Types.COMPLETION_PROGRESS, tableClass, '', null, null, '', map),
        new Table(Types.BUTTON, 'ico tg-report', ''),
        new Table(Types.BUTTON, 'ico tg-dashboard1', '')
      ];
      this.fullTable.push(tableRow);
      this.displayedTable = this.fullTable;
    }
    this.isExtendedTable = this.fullTable.length > 10;
    this.filterDataUsingDate();
    this.cdr.detectChanges();
  }

  onStartDateChanged(event) {
    this.startDate = this.getDateData(event);
    this.formattedStartDate = this.startDate.isDateValid ? this.changeDPDateFormat(this.startDate.date) : null;
    if(this.endDate.isDateValid) {
      this.filterDataUsingDate();
    }
  }

  onEndDateChanged(event) {
    this.endDate = this.getDateData(event);
    this.formattedEndDate = this.endDate.isDateValid ? this.changeDPDateFormat(this.endDate.date) : null;
    if(this.startDate.isDateValid) {
      this.filterDataUsingDate();
    }
  }

  /**
   * Filter data using start and end dates
   */
  filterDataUsingDate() {
    if ((this.fullTable && this.fullTable.length) && (this.startDate.isDateValid || this.endDate.isDateValid)) {
      if (this.dateValidation(this.startDate, this.endDate)) {
        this.dateFilteredTable = [];
        for (const record of this.fullTable) {
          const completedDate = this.dateConversion(record[3].title);
          if (completedDate) {
            completedDate.setHours(0, 0, 0, 0);
          }

          const sentDate = this.dateConversion(record[2].title);
          if(sentDate) {
            sentDate.setHours(0, 0, 0, 0);
          }
          if (completedDate && completedDate >= this.formattedStartDate && completedDate <= this.formattedEndDate) {
            this.dateFilteredTable.push(record);
          } else if (this.formattedStartDate != null && this.formattedEndDate == null) {
            if (sentDate >= this.formattedStartDate) {
              this.dateFilteredTable.push(record);
            }
          } else if (this.formattedStartDate == null && this.formattedEndDate != null) {
            if (completedDate && completedDate <= this.formattedEndDate) {
              this.dateFilteredTable.push(record);
            }
          }else if(this.formattedStartDate && this.formattedEndDate){
            if((sentDate && sentDate >= this.formattedStartDate && sentDate <= this.formattedEndDate) || 
                (completedDate && completedDate >= this.formattedStartDate && completedDate <= this.formattedEndDate)) {
              this.dateFilteredTable.push(record);
            } 
          }
          
        }
        this.displayedTable = this.dateFilteredTable;
      } else {
        this.clearDates();
      }
    } else {
      this.dateFilteredTable = null;
      this.displayedTable = this.fullTable;
    }
    this.filterDataWithStatus(this.statusDropdown.selectedIndex);
  }

  clearDates() {
    this.startDate = this.endDate = { date: null, isDateValid: false };
    this.startDateBox.datePicker.clearDate();
    this.endDateBox.datePicker.clearDate();
  }

  /**
   * Set selected index of dropdown
   * @param event contains id and text of selected option
   */
  statusFilterChanged(event) {
    this.statusDropdown.selectedIndex = event.id;
    this.filterDataWithStatus(this.statusDropdown.selectedIndex);
  }

  /**
   * Filter data according to status selected in dropdown
   * @param statusId id of selected option
   */
  filterDataWithStatus(statusId: number) {
    if (!this.fullTable) {
      return;
    }

    switch (statusId) {
      case 0:
      case -1:
        this.displayedTable = this.dateFilteredTable ? this.dateFilteredTable : this.fullTable;
        break;
      case 1:
        this.filterDataUsingClass(STATUS_CLASS.COMPLETED);
        break;
      case 2:
        this.filterDataUsingClass(STATUS_CLASS.INCOMPLETE);
        break;
    }
  }

  /**
   * Filter data using class applied to data
   * @param className class applied if training completed or not
   */
  filterDataUsingClass(className: string) {
    this.displayedTable = this.dateFilteredTable ? this.dateFilteredTable : this.fullTable;
    const filteredTable = [];
    
    this.displayedTable.forEach((currentCandidate) => {
      if(currentCandidate[3].title !== "" && className === STATUS_CLASS.COMPLETED) {
        filteredTable.push(currentCandidate);        
      }
      if (currentCandidate[3].title === "" && className === STATUS_CLASS.INCOMPLETE) {
        filteredTable.push(currentCandidate);
      }
    });
    this.displayedTable = filteredTable;
  }

  viewButtonClicked(event) {
    if (event.colIndex === 6) {
      const currentApplication = this.applicationList[event.index];
      const queryParams: ReviewModeParams = {
        mode: this.reviewMode,
        candidateId: currentApplication.candidateUserId,
        candidateEmail: currentApplication.candidateEmail,
      };

      let url = `${this.redirectUrl}/${this.dashboardRoute}`;
      url += `?${this.queryParam1}=${encodeURIComponent(btoa(JSON.stringify(queryParams)))}`;
      url += `&${this.queryParam2}=1`;

      window.open(url, null, null, true);
    } else {
      this.pieChartPieChartType = 0; // inintial set after it will change in popup component
      this.pieChartItemValue = 1;
      let selectedATC;
      for (const data of this.trainingData) {
        if (this.atcSelected === data.autoTrainingCodeId) {
          selectedATC = data;
        }
      }
      this.applicationList[event.index].skillList.sort(function (a, b) {
        return a.skillName > b.skillName;
      });
      const skillList = this.applicationList[event.index].skillList;
      const sortedSkillList = [];
      for (const data of MainComponent.trainingList) {
        for (const skill of skillList) {
          if (skill.skillId === data.skillId) {
            sortedSkillList.push(skill);
          }
        }
        if (skillList.length === sortedSkillList.length) {
          break;
        }
      }
      this.currentSelectedAccordion = {
        applicationid: this.applicationList[event.index].applicationId,
        candidateEmail: this.applicationList[event.index].candidateEmail,
        autoTrainingCodeName: selectedATC.autoTrainingCodeName,
        desc: selectedATC.description,
        skillList: sortedSkillList,
      };
      this.popupState = true;
    }
  }
  
  shortcurrentselectedAccordion(accordion) {
    for (const skill of accordion.skillList) {
      const index = this.findIndexOfSkillInClientTrainingList(skill.skillName);
      if (index !== -1) {
        skill.priority = index;
      } else {
        skill.priority = 10000;
      }
    }
    accordion.skillList = this.shortAcordionSkillTopriority(accordion);
    return accordion;
  }
  shortAcordionSkillTopriority(accordion) {
    return accordion.skillList.sort(function (a, b) {
      return a.priority - b.priority;
    });
  }

  popupClose() {
    this.popupState = false;
  }

}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/training-management/reporting-training/reporting-training-home/reporting-training-home.component.ts